var css = require('sheetify');
var choo = require('choo');

css('tachyons');
css('./lib/main.css');

var app = choo();
if (process.env.NODE_ENV !== 'production') {
  app.use(require('choo-devtools')());
} else {
  // app.use(require('choo-service-worker')());
}

app.use(require('./stores/quiz'));

if (process.env.NODE_ENV !== 'production') {
  app.route('/', require('./views/start'));
  app.route('/question/:questionNumber', require('./views/question'));
  app.route('/scorecard', require('./views/scorecard'));
} else {
  // app.route('/dist', require('./views/start'));
  app.route('/can-you-spot-the-terrorist', require('./views/start'));
  app.route('/can-you-spot-the-terrorist/question/:questionNumber', require('./views/question'));
  app.route('/can-you-spot-the-terrorist/scorecard', require('./views/scorecard'));
}

app.route('/*', require('./views/404'));

module.exports = app.mount('#app');
